import { useTranslation } from 'react-i18next';

export default function CtaBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20lifestyle%20flat%20lay%20with%20curated%20fashion%20accessories%20shoes%20bag%20and%20sunglasses%20on%20cream%20linen%20surface%2C%20soft%20natural%20window%20light%20creating%20gentle%20shadows%2C%20editorial%20ecommerce%20photography%2C%20clean%20harmonious%20composition%2C%20contemporary%20European%20aesthetic&width=1600&height=600&seq=cta-banner-v3&orientation=landscape"
          alt="Kakobuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-black/15 to-black/25"></div>
      </div>

      <div className="relative w-full px-6 md:px-10 py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
            <div className="max-w-xl">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
                {t('cta.title')}
              </h2>
              <p className="text-base text-background-50/80 leading-relaxed">
                {t('cta.subtitle')}
              </p>
            </div>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group shrink-0 inline-flex items-center gap-3 px-8 py-4 bg-background-50 text-foreground-900 font-semibold rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>{t('cta.button')}</span>
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-full group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}